import { useAppContext } from "app/AppContext";
import PerfilForm from "entity/Perfil/components/PerfilForm";
import PerfilConsulta from "entity/Perfil/components/PerfilConsulta";
import UserCreate from "entity/Perfil/components/UserCreate";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAdmin } from 'useAuth'

export default function RoutesMenusPerfil() {
    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    const isAdmin = useIsAdmin();

    useEffect(() => {
        if (isAdmin) {
            addRoute({ uid: "perfil", title: "Perfil", route: "perfil", element: <PerfilForm /> });
            addRoute({ uid: "createUser", title: "CreateUser", route: "createUser", element: <UserCreate /> });

            addMenu({
                uid: "consultaPerfil",
                text: "Perfis",
                sequence: "222225",
                iconName: "Person",
                action: () => {
                    navigate("/consulta-perfil");
                },
            });

            addRoute({ uid: "consultaPerfil", title: "Perfis", route: "consulta-perfil", element: <PerfilConsulta /> });
        }

        return () => {
            removeMenusRoutes(["perfil", "consultaPerfil"]);
        };
    }, [addMenu, addRoute, isAdmin, navigate, removeMenusRoutes]);

    return null;
}
